<template>
  <div class="lead-list-page">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    />

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editLead="selectedLead"
    />

    <v-card :loading="loading" outlined class="lead-card">
      <div class="lead-list-header">
        <div>
          <div class="lead-list-title">Lead List</div>
          <div class="lead-list-subtitle">
            {{ Leads.length }} leads found
          </div>
        </div>

        <div class="lead-list-actions">
          <v-btn
            v-if="checkRightStatus(43)"
            small
            rounded
            color="primary"
            dark
            @click="add"
          >
            <v-icon left small>mdi-plus</v-icon>
            New Lead
          </v-btn>
        </div>
      </div>

      <div class="lead-filter-bar">
        <div class="filter-field search-field">
          <div class="filter-label">Search</div>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            autofocus
            dense
            label="Business, contact, phone, email"
            single-line
            hide-details
            clearable
            class="lead-search"
          />
        </div>

        <div class="filter-field status-field">
          <div class="filter-label">Status</div>
          <v-select
            dense
            outlined
            @change="getList()"
            :items="leadStatus"
            v-model="selectedStatus"
            label="Lead status"
            hide-details
            class="lead-status"
          />
        </div>
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="Leads"
          :search="search"
          :loading="loading"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left" @click="profile(item)">
                {{ item.createdAt | moment("from", "now") }}
              </td>

              <td class="text-left" @click="profile(item)">
                <div class="font-weight-bold">{{ item.name }}</div>
                <div class="caption grey--text" v-if="item.address">
                  {{ item.city }} {{ item.state }}
                </div>
              </td>

              <td class="text-left" @click="profile(item)">
                {{ item.contactName || "--" }}
              </td>

              <td class="text-left" @click="profile(item)">
                <span v-if="item.phoneNumber">
                  {{ item.phoneNumber | USPhoneNumber }}
                </span>
                <span v-else>--</span>
              </td>

              <td class="text-left" @click="profile(item)">
                {{ item.email || "--" }}
              </td>

              <td class="text-left" @click="profile(item)">
                <v-chip small label :color="statusColor(item.status)" :text-color="statusTextColor(item.status)">
                  {{ item.status || "Not Set" }}
                </v-chip>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="menu-button">
                    <v-list-item @click="profile(item)">
                      <v-list-item-title>View Profile</v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item
                      v-if="checkRightStatus(44)"
                      @click="editLead(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="checkRightStatus(45)"
                      @click="deleteLead(item)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import leadService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "lead-list",

  components: {
    Create,
    Edit,
  },

  data() {
    return {
      leadStatus: [
        "Hot Lead",
        "Warm Lead",
        "Cold",
        "Not Ordered",
        "Closed",
        "Convert",
        "Dead",
      ],
      createDialog: false,
      editDialog: false,
      selectedLead: null,
      headers: [
        {
          text: "Created",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Business",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Contact",
          align: "left",
          value: "contactName",
          sortable: true,
        },
        {
          text: "Phone",
          align: "left",
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: "Email",
          value: "email",
          sortable: true,
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      Leads: [],
      selectedStatus: "Not Ordered",
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },

  created() {
    this.getList();
    this.$events.listen("leadListEvent", () => this.getList());
    document.title = "smplsale - Lead List";
  },

  beforeDestroy() {
    this.$events.remove("leadListEvent");
  },

  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  methods: {
    profile(lead) {
      this.$router.push({ path: `/lead/${lead.id}/profile` });
    },

    add() {
      this.createDialog = true;
    },

    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;

      return leadService
        .getAll({ status: this.selectedStatus })
        .then((response) => {
          this.loading = false;
          this.Leads = response.data || [];
          return response;
        })
        .catch((error) => {
          this.loading = false;
          this.Leads = [];
          throw error;
        });
    },

    editLead(lead) {
      this.selectedLead = lead;
      this.editDialog = true;
    },

    deleteLead(lead) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          leadService.delete(lead.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Lead has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },

    statusColor(status) {
      if (status === "Hot Lead") return "red lighten-4";
      if (status === "Warm Lead") return "orange lighten-4";
      if (status === "Cold") return "blue lighten-4";
      if (status === "Closed" || status === "Convert") return "green lighten-4";
      if (status === "Dead") return "grey lighten-3";
      return "amber lighten-4";
    },

    statusTextColor(status) {
      if (status === "Hot Lead") return "red darken-4";
      if (status === "Warm Lead") return "orange darken-4";
      if (status === "Cold") return "blue darken-4";
      if (status === "Closed" || status === "Convert") return "green darken-4";
      if (status === "Dead") return "grey darken-3";
      return "amber darken-4";
    },
  },
};
</script>

<style scoped>
.lead-list-page {
  width: 100%;
}

.lead-card {
  border-radius: 20px;
  background: #ffffff;
}

.lead-list-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e2e8f0;
}

.lead-list-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.lead-list-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.lead-list-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lead-filter-bar {
  padding: 12px 16px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e2e8f0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.search-field {
  min-width: 340px;
}

.lead-search {
  width: 380px;
  max-width: 380px;
}

.status-field {
  min-width: 210px;
}

.lead-status {
  width: 220px;
  max-width: 220px;
}

.pointer:hover {
  background: #f8fafc;
}

@media (max-width: 600px) {
  .lead-list-actions {
    width: 100%;
  }

  .lead-list-actions .v-btn {
    width: 100%;
  }

  .search-field,
  .lead-search,
  .status-field,
  .lead-status {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
</style>
